import React from "react";
import {DialogTitle} from "@material-ui/core";
import styled from "styled-components";

interface EmployeePageHeaderProps {
    title: string;
}

const TitleContainer = styled(DialogTitle)`
  color: white;
  background-color: #046A38;
  min-height: 64px;
  box-sizing: border-box;
`;

const Title = styled.p`
    margin: 0;
`;

const EmployeeHeaderPage = (props: EmployeePageHeaderProps) => {
    const {title} = props;
    // Profile
    return (
        <TitleContainer>
            <Title>
                {title}
            </Title>
        </TitleContainer>
    );
};

export default EmployeeHeaderPage;